import getCreateAttachmentHandlerForLocalFile from './getCreateAttachmentHandlerForLocalFile';
import { getCreateAttachmentHandlerForUpsell } from './getCreateAttachmentHandlerForUpsell';
import datapoints from '../datapoints';
import AttachmentMultiMenuEntry from '../types/AttachmentMultiMenuEntry';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { ControlIcons } from 'owa-control-icons';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-mail-strings';

const styles = require('../components/AttachmentMultiMenuEntryIcons.scss');
const classNames = require('classnames/bind').bind(styles);

const attachmentMultiMenuEntry: AttachmentMultiMenuEntry = {
    computer: {
        isEnabled: () => true,
        text: () => strings.computerMenuText,
        iconProps: {
            iconName: ControlIcons.System,
            styles: {
                root: classNames(styles.iconRoot, styles.iconRootComputer),
            },
        },
        getCreateAttachmentHandler: getCreateAttachmentHandlerForLocalFile,
        logUsage: (entrySource: { toString: () => string }) => {
            const { name: eventName, customData } = datapoints.FPDualEntryComputer.datapoint;
            logUsage(eventName, customData(entrySource.toString()));
        },
    },
    onlineLocation: {
        isEnabled: () => true,
        text: () => strings.cloudLocationsMenuText,
        iconProps: {
            iconName: ControlIcons.Cloud,
            styles: {
                root: classNames(styles.iconRoot, styles.iconRootCloud),
            },
        },
        getCreateAttachmentHandler: (_, createAttachment) => {
            return (files, shouldShare, isInline) => {
                const baseProperties = { isInline, isHiddenInline: false };
                const properties: CreateAttachmentsProperties = shouldShare
                    ? { ...baseProperties, shouldShare: true }
                    : { ...baseProperties, shouldShare: false };

                createAttachment(files, properties);
            };
        },
        logUsage: (entrySource: { toString: () => string }) => {
            const { name: eventName, customData } = datapoints.FPDualEntryFilePicker.datapoint;
            logUsage(eventName, customData(entrySource.toString()));
        },
    },
    uploadAndShareFromCloud: {
        isEnabled: () => {
            const configuration = getUserConfiguration();
            return (
                isFeatureEnabled('doc-attachment-upsellEntryPoint') &&
                configuration.AttachmentPolicy.AttachmentDataProviderAvailable &&
                configuration.AttachmentPolicy.ReferenceAttachmentsEnabled
            );
        },
        text: () => strings.uploadAndShareFromCloudMenuText,
        ariaLabel: () => strings.uploadAndShareFromCloudMenuTooltip,
        iconProps: {
            iconName: ControlIcons.CloudUpload,
            styles: {
                root: classNames(styles.iconRoot, styles.iconRootUploadAndShare),
            },
        },
        getCreateAttachmentHandler: getCreateAttachmentHandlerForUpsell,
        logUsage: (entrySource: { toString: () => string }) => {
            const {
                name: eventName,
                customData,
            } = datapoints.FPMultiEntryUploadAndShareFromCloud.datapoint;
            logUsage(eventName, customData(entrySource.toString()));
        },
    },
};

export default attachmentMultiMenuEntry;
